module.exports = __webpack_public_path__ + "47cf698e57af0651962238787bea4d2f.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansbolditalic.ttf
// module id = 673
// module chunks = 57